import { Link } from "react-router-dom";
import { CheckCircle2, CalendarPlus, MessageCircle, Settings2 } from "lucide-react";
import { BookingSummary } from "./BookingSummary";
import { downloadIcs } from "./utils";
import { useBT } from "./i18n";
import { SITE } from "@/data/site";

export const Confirmation = ({ booking }) => {
  const { t } = useBT();
  const manage = `/book/manage/${booking.manage_token}`;
  const wa = `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(`Hi Tribe! My booking code is ${booking.code}.`)}`;
  const pill = "inline-flex items-center gap-2 border rounded-full px-4 py-2 text-xs hover:border-[#15262d] transition-colors";
  return (
    <section className="bg-white border rounded-xl p-8 max-w-xl animate-in fade-in zoom-in-95" data-testid="book-confirmation">
      <CheckCircle2 className="text-emerald-600" size={36} />
      <h2 className="font-serif text-3xl font-light mt-4">{t.booked}</h2>
      <p className="text-sm text-[#1d2b31]/60 mt-2">
        {t.code} <span className="font-mono font-semibold text-[#15262d]" data-testid="book-confirmation-code">{booking.code}</span>
      </p>
      <div className="mt-6"><BookingSummary booking={booking} /></div>
      {booking.notes_copy && <p className="text-xs text-[#8a7347] mt-5">{booking.notes_copy}</p>}
      <div className="flex flex-wrap gap-2 mt-7">
        <button onClick={() => downloadIcs(booking)} data-testid="book-add-calendar" className={pill}>
          <CalendarPlus size={14} /> {t.addCal}
        </button>
        <a href={wa} target="_blank" rel="noopener noreferrer" data-testid="book-whatsapp" className={pill}>
          <MessageCircle size={14} /> {t.whatsapp}
        </a>
        <Link to={manage} data-testid="book-manage-link"
          className="inline-flex items-center gap-2 bg-[#15262d] text-white rounded-full px-4 py-2 text-xs hover:bg-[#b09873] transition-colors">
          <Settings2 size={14} /> {t.manage}
        </Link>
      </div>
      <p className="text-xs text-[#1d2b31]/60 mt-5">{t.saveLink}</p>
    </section>
  );
};
